import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { CaptchaStyled } from "./CaptchaStyled";
var Captcha = React.forwardRef(function (_a, ref) {
    var reCaptchaSiteKey = _a.reCaptchaSiteKey, _b = _a.captchaError, captchaError = _b === void 0 ? "" : _b, _c = _a.onCaptchaChange, onCaptchaChange = _c === void 0 ? function (newToken) { } : _c, _d = _a.useReCaptcha, useReCaptcha = _d === void 0 ? true : _d;
    return (React.createElement(CaptchaStyled, null, useReCaptcha ? (React.createElement("div", { className: "captcha-container" },
        React.createElement(ReCAPTCHA, { ref: function (el) {
                if (ref !== null) {
                    ref.current = el;
                }
            }, sitekey: reCaptchaSiteKey, onChange: onCaptchaChange }),
        captchaError === "" ? (React.createElement(React.Fragment, null)) : (React.createElement("span", { className: "error-msg" }, captchaError)))) : (React.createElement(React.Fragment, null))));
});
export default Captcha;
//# sourceMappingURL=Captcha.js.map